import { InsightsHubArticleResponse } from "@insightsHub/models";
import { AppThunkAPI } from "@shared/models/redux";

type CallInsightsHubArticleApi = (articleId: string) => AppThunkAPI<Promise<InsightsHubArticleResponse>>;

export const callInsightsHubArticleApi: CallInsightsHubArticleApi =
  (articleId) => async (_dispatch, _getState, extra) => {
    const response = await extra<InsightsHubArticleResponse>(`/entitlements/v1/user/cms/portals/${articleId}`);

    return response.data;
  };
